import Swiper, { Navigation } from 'swiper'

Swiper.use([Navigation])

const sliders = []

let slidersHtml = document.querySelectorAll('.slider-avis')

if (slidersHtml.length) {
  slidersHtml.forEach(sliderHtml => {
    sliders.push(new Swiper(sliderHtml, {
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      autoHeight: true,
      watchOverflow: true,
    }))
  })
}



// WEBPACK FOOTER //
// ./scripts/modules/avis.js